import {
    RouteEditorModal,
    RouteEditorModalState,
} from "../../RouteEditor.types";
import { DeleteScheduleModal } from "../DeleteScheduleModal";
import { EditScheduleModal } from "../EditScheduleModal";
import { MoveScheduleModal } from "../MoveScheduleModal";
import { WarningDebtModal } from "../WarningDebtModal";

export interface RouteModalsContainerProps {
    modalState: RouteEditorModalState;
    onClose: () => void;
    onAfterConfirm?: () => Promise<void>;
}

export const ModalsContainer = ({
    modalState,
    onClose,
    onAfterConfirm = async () => {},
}: RouteModalsContainerProps) => {
    if (!modalState) return null;

    const { type } = modalState;

    switch (type) {
        case RouteEditorModal.EditSchedule:
            return (
                <EditScheduleModal
                    payload={modalState.payload}
                    onClose={onClose}
                    onApprove={onAfterConfirm}
                />
            );

        case RouteEditorModal.MoveSchedule:
            return (
                <MoveScheduleModal
                    payload={modalState.payload}
                    onClose={onClose}
                    onApprove={onAfterConfirm}
                />
            );
        case RouteEditorModal.WarningDebt: {
            return (
                <WarningDebtModal
                    payload={modalState.payload}
                    onClose={onClose}
                />
            );
        }

        case RouteEditorModal.DeleteSchedule: {
            return (
                <DeleteScheduleModal
                    payload={modalState.payload}
                    onClose={onClose}
                    onApprove={onAfterConfirm}
                />
            );
        }

        default:
            return null;
    }
};
